import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';
const swal = require('sweetalert');

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent{

     coupons:Array<any>;
     couponsData: FirebaseListObservable<any>;
    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.couponsData = af.list('/coupons');
     this.couponsData.subscribe((res)=>{
         this.coupons = res;
     });
       
    }
  
  
  couponDelete(key:any){
    swal({
            title: 'Are you sure?',
            text: 'Your will not be able to recover this data!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            closeOnConfirm: false,
            closeOnCancel: false
        }, (isConfirm) => {
            if (isConfirm) {
               this.couponsData.remove(key).then((res)=>{
                   swal('Deleted!','Coupons Deleted Successfully!', 'success');
                 })
              } else {
                swal('Cancelled', 'Your data is safe :)', 'error');
            }
        });
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/coupons/coupons.component.ts